/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OemSlaContractDto } from './OemSlaContractDto';
import {
    OemSlaContractDtoFromJSON,
    OemSlaContractDtoFromJSONTyped,
    OemSlaContractDtoToJSON,
    OemSlaContractDtoToJSONTyped,
} from './OemSlaContractDto';

/**
 * 
 * @export
 * @interface OemPartnerGroupDto
 */
export interface OemPartnerGroupDto {
    /**
     * 
     * @type {string}
     * @memberof OemPartnerGroupDto
     */
    relationshipId: string;
    /**
     * 
     * @type {string}
     * @memberof OemPartnerGroupDto
     */
    partnerOrgId: string;
    /**
     * 
     * @type {string}
     * @memberof OemPartnerGroupDto
     */
    partnerName: string;
    /**
     * 
     * @type {OemSlaContractDto}
     * @memberof OemPartnerGroupDto
     */
    slaContract?: OemSlaContractDto | null;
}

/**
 * Check if a given object implements the OemPartnerGroupDto interface.
 */
export function instanceOfOemPartnerGroupDto(value: object): value is OemPartnerGroupDto {
    if (!('relationshipId' in value) || value['relationshipId'] === undefined) return false;
    if (!('partnerOrgId' in value) || value['partnerOrgId'] === undefined) return false;
    if (!('partnerName' in value) || value['partnerName'] === undefined) return false;
    return true;
}

export function OemPartnerGroupDtoFromJSON(json: any): OemPartnerGroupDto {
    return OemPartnerGroupDtoFromJSONTyped(json, false);
}

export function OemPartnerGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OemPartnerGroupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'relationshipId': json['relationshipId'],
        'partnerOrgId': json['partnerOrgId'],
        'partnerName': json['partnerName'],
        'slaContract': json['slaContract'] == null ? undefined : OemSlaContractDtoFromJSON(json['slaContract']),
    };
}

export function OemPartnerGroupDtoToJSON(json: any): OemPartnerGroupDto {
    return OemPartnerGroupDtoToJSONTyped(json, false);
}

export function OemPartnerGroupDtoToJSONTyped(value?: OemPartnerGroupDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationshipId': value['relationshipId'],
        'partnerOrgId': value['partnerOrgId'],
        'partnerName': value['partnerName'],
        'slaContract': OemSlaContractDtoToJSON(value['slaContract']),
    };
}

